import React, {Component, KeyboardEvent} from "react"
import styles from "./input.module.css"
import {PasswordEyeIcon} from "./PasswordEyeIcon"

interface Props {
    placeholder?: string
    onChange: (value: string) => void
    disabled?: boolean
    value: string
    type?: "text" | "email" | "tel" | "date" | "password"
    onKeyDown?: (event: KeyboardEvent<Element>) => void
    onKeyPress?: (event: KeyboardEvent<Element>) => void
    onKeyUp?: (event: KeyboardEvent<Element>) => void
    onBlur?: (event: any) => void
    onFocus?: (event: any) => void
}

interface State {
    showPassword: boolean
}

export class Input extends Component<Props, State> {
    public state: State = {
        showPassword: false
    }

    private inputRef = React.createRef<HTMLInputElement>()
    private pendingSelection: {start: number | null; end: number | null} = {
        start: null,
        end: null
    }

    private onChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.props.onChange(event.target.value)
    }

    private onTogglePassword = () => {
        if (this.props.disabled) return

        const selectionStart = this.pendingSelection.start
        const selectionEnd = this.pendingSelection.end

        this.setState(
            (prev) => ({showPassword: !prev.showPassword}),
            () => {
                const elAfter = this.inputRef.current
                if (!elAfter) return
                requestAnimationFrame(() => {
                    elAfter.focus()
                    if (selectionStart !== null && selectionEnd !== null) {
                        elAfter.setSelectionRange(selectionStart, selectionEnd)
                    }
                })
                this.pendingSelection = {start: null, end: null}
            }
        )
    }

    public render() {
        const {
            placeholder,
            disabled,
            value,
            onKeyDown,
            onKeyPress,
            onKeyUp,
            onBlur,
            onFocus,
            type = "text"
        } = this.props

        const isPassword = type === "password"
        const inputType = isPassword ? (this.state.showPassword ? "text" : "password") : type

        return (
            <div className={isPassword ? styles.wrapperWithToggle : styles.wrapper}>
                <input
                    ref={this.inputRef}
                    className={`${styles.input} ${isPassword ? styles.inputWithToggle : ""}`}
                    type={inputType}
                    value={value}
                    onChange={this.onChange.bind(this)}
                    placeholder={placeholder}
                    disabled={disabled}
                    onKeyDown={onKeyDown}
                    onKeyPress={onKeyPress}
                    onKeyUp={onKeyUp}
                    onBlur={onBlur}
                    onFocus={onFocus}
                />

                {isPassword && (
                    <button
                        type="button"
                        className={styles.toggleButton}
                        onMouseDown={(e) => {
                            const el = this.inputRef.current
                            this.pendingSelection = {
                                start: el?.selectionStart ?? null,
                                end: el?.selectionEnd ?? null
                            }
                            e.preventDefault()
                            e.stopPropagation()
                            this.onTogglePassword()
                        }}
                        disabled={disabled}
                        aria-label={this.state.showPassword ? "Hide password" : "Show password"}
                    >
                        <PasswordEyeIcon showPassword={this.state.showPassword} />
                    </button>
                )}
            </div>
        )
    }
}
